import { AuthObject } from '@/types/index'
import { encryptPassword } from '@/utils/formatter'
import { AxiosPromise } from 'axios'
import { useApi } from '../../useFondasiFetch'

type SignUpResponseObject = AuthObject

export type SignUpFormData = {
  name: string,
  email: string,
  password: string,
  clientId: string
}

type Result = {
  signedUpData?: SignUpResponseObject | undefined,
  signingUp?: boolean,
  errorSignUp?: any,
  signUp: (payload: SignUpFormData, invitation?: { token: string }) => AxiosPromise<SignUpResponseObject>
}

export default function useSignup(): Result {
  const { data, error, isValidating, call3 } = useApi<SignUpResponseObject>()

  return {
    signedUpData: data,
    signingUp: isValidating,
    errorSignUp: error,
    signUp: (payload: SignUpFormData, invitation?: { token: string }) => {
      return call3({
        url: '/auth/register',
        method: 'post',
        data: {
          invitation,
          globalUser: { ...payload, password: encryptPassword(payload.password) }
        }
      })
    }
  }
}
